import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { getHistorySaga } from './getHistorySaga';

export function* historySaga() {
  yield all([takeEvery(ACTIONS.GET_HISTORY, getHistorySaga)]);
}
